import { Flex, Link, Paragraph } from '@customerio/pluma-components/react';
import type { SignupStep } from '../utils/steps';

/**
 * The onboarding steps collect product answers after the account decision is
 * already made, so the notice would be noise there. Every other step shows it.
 */
const STEPS_WITHOUT_TERMS_NOTICE = new Set<SignupStep>([
  'onboarding_usage',
  'onboarding_personalize',
  'channels',
  'startup_complete',
]);

export function shouldShowTermsNotice(step: SignupStep): boolean {
  return !STEPS_WITHOUT_TERMS_NOTICE.has(step);
}

type SignupTermsNoticeProps = {
  className?: string;
};

/**
 * The terms-of-service notice under the signup panel. Informational only —
 * there is no checkbox; creating an account is the acceptance.
 */
export function SignupTermsNotice({ className }: SignupTermsNoticeProps) {
  return (
    <Flex justifyContent="center" className={className}>
      <Paragraph variant="secondary" sizeVariant="xs">
        By creating an account, you agree to our{' '}
        <Link href="https://customer.io/legal/terms-of-service" variant="secondary" isExternal>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href="https://customer.io/legal/privacy-policy" variant="secondary" isExternal>
          Privacy Policy
        </Link>
        .
      </Paragraph>
    </Flex>
  );
}
